// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/TicketTrendSection.js
//
// Purpose:
// Service Ticket Trend
//
// Dashboard Row
//
// Created vs Closed
// 12 Month Trend
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

export default function TicketTrendSection({

  data = [],

  onMonthClick,

}) {

  function handleClick(row) {

    if (
      !row ||
      !onMonthClick
    ) {
      return;
    }

    onMonthClick(
      row.month
    );
  }

  return (

    <DashboardCard

      title="Service Ticket Trend"

      subtitle="Created vs Closed Tickets (12 Month Trend)"

      height={500}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <LineChart
          data={data}
          onClick={handleClick}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="month"
          />

          <YAxis />

          <Tooltip />

          <Legend />

          <Line
            type="monotone"

            dataKey="created"

            stroke="#2563eb"

            strokeWidth={3}

            activeDot={{
              r: 8,
            }}
          />

          <Line
            type="monotone"

            dataKey="closed"

            stroke="#10b981"

            strokeWidth={3}

            activeDot={{
              r: 8,
            }}
          />

        </LineChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}